import React, { Component } from 'react';
import { Row, Col, Modal, Form, FormField, RadioBoxList, Button, Translate, Icon, AutoComplete, CheckBox, DatePicker } from '$common';
import CSSModules from 'react-css-modules';
import style from './gallery.scss';
import { cloneDeep, isEmpty } from 'lodash';
import { errors } from '$lib/normalize';
import moment from 'moment';

const defaults = {
  project_ids: [],
  folder_structure: 'single',
  media_types: {
    image: true,
    voice_record: true,
    video: true
  }
}

@CSSModules(style, { allowMultiple: true })
export default class GalleryReport extends Component {
  state = {
    form: {
      ...defaults
    },
    projects: {},
    errors: {},
    modalIsOpen: false
  }

  submit(form) {
    let errorMessages = [];
    let formClone = cloneDeep(form);
    formClone.media_types = [];

    if (form.project_ids.length < 1) {
      errorMessages.push({ "attribute": "selected_project_id", "errors": [Translate.get('project_ids_empty_error')] })
    }

    Object.keys(form.media_types).map( type => {
      if (form.media_types[type]) {
        formClone.media_types.push(type);
      }
    });

    if (formClone.media_types.length < 1) {
      errorMessages.push({ "attribute": "media_types", "errors": [Translate.get('media_types_empty_error')] })
    }

    if (errorMessages.length > 0) {
      this.setState({ errors: errors(errorMessages) });
    } else {
      this.setState({ errors: {}, modalIsOpen: false, form: { ...defaults }, projects: {} });
      this.props.createReport(formClone, Translate.get('report_request_success'));
    }
  }

  onChangeForm(e) {
    e.project_ids = this.state.form.project_ids;
    this.setState({ form: e, errors: {} });
  }

  get projects() {
    return this.state.projects;
  }

  addSelectedProject() {
    const { form, projects } = this.state;
    let formClone = cloneDeep(form);
    let projectsClone = cloneDeep(projects);

    if (!projectsClone.hasOwnProperty(form.selected_project_id) && form.project_ids.indexOf(form.selected_project_id) === -1) {
      formClone.project_ids.push(form.selected_project_id);

      this.props.getProject(form.selected_project_id).then(data => {
        projectsClone = {
          ...projects,
          [form.selected_project_id]: data.data
        }

        this.setState({ form: formClone, projects: projectsClone });
      })
    }
  }

  removeSelectedProject(id) {
    const { form, projects } = this.state;
    let formClone = cloneDeep(form);
    let projectsClone = cloneDeep(projects);

    formClone.project_ids.splice(form.project_ids.indexOf(id), 1);
    delete projectsClone[id];

    this.setState({ form: formClone, projects: projectsClone });
  }

  formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

  render() {
    const { getProjects } = this.props;
    const { form, errors, modalIsOpen } = this.state;

    return (
      <div>
        <Button
          type="ghost"
          block
          style={{ padding: '15.5px 0px', fontSize: '13px', position: 'relative', zIndex: '123' }}
          onClick={() => this.setState({ modalIsOpen: true })}
        >
          <span style={{ marginRight: '3px', display: 'inline-block' }}>
            {Translate.get('export_gallery')}
          </span>
          <Icon name="cloud-download" />
        </Button>
        <Modal
          isOpen={modalIsOpen}
          closeable={true}
          title={Translate.get('export_gallery')}
          onCloseRequest={() => this.setState({ modalIsOpen: false, form: { ...defaults }, errors: {}, projects: {} })}
        >
          <Form onSubmit={() => this.submit(form)} defaults={form} onChange={::this.onChangeForm} errors={errors}>
            <p>{Translate.get('projects')}</p>
            <div styleName="input-group">
              <FormField name="selected_project_id">
                <div styleName="input">
                  <AutoComplete searchEndpoint={getProjects} placeholder={Translate.get('type_project_name')} />
                </div>
                <Button type="ghost" onClick={() => this.addSelectedProject()}>
                  <Icon name="plus" /> {Translate.get('add_project')}
                </Button>
              </FormField>
            </div>

            <p>{Translate.get('date_range')}</p>
            <div styleName="input-group">
              <Row>
                <Col md="1/2">
                  <DatePicker
                    placeholderText={Translate.get('start_date')}
                    name="start_date"
                  />
                </Col>
                <Col md="1/2">
                  <DatePicker
                    placeholderText={Translate.get('finish_date')}
                    name="end_date"
                  />
                </Col>
              </Row>
            </div>

            <ul styleName="project-list">
              {
                form.project_ids.map( (id, index) => (
                  <li key={index}>
                    <Button type="danger" size="micro" styleName="remove-button" onClick={() => this.removeSelectedProject(id)}>
                      <Icon name="times" />
                    </Button>
                    {this.projects[id].name}
                  </li>
                ))
              }
            </ul>

            <p>Folder Structure</p>
            <FormField name="folder_structure">
              <RadioBoxList
                options={[
                  { label: Translate.get('folder_structure_single'), value: 'single' },
                  { label: Translate.get('folder_structure_projects'), value: 'projects' },
                  { label: Translate.get('folder_structure_tasks'), value: 'tasks' },
                  { label: Translate.get('folder_structure_submissions'), value: 'submissions' }
                ]}
              />
            </FormField>
            
            <p>{Translate.get('media_types')}</p>
            <FormField name="media_types">
              <FormField name="media_types[image]" label={Translate.get('image')}>
                <CheckBox />
              </FormField>
              <FormField name="media_types[voice_record]" label={Translate.get('voice_record')}>
                <CheckBox />
              </FormField>
              <FormField name="media_types[video]" label={Translate.get('video')}>
                <CheckBox />
              </FormField>
            </FormField>

            <Button
              type="success"
              submit
              block>
              {Translate.get('submit')}
            </Button>
          </Form>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/gallery/gallery-report.js